<template>
  <b-container fluid>
    <b-row>
      <b-col />
      <b-col>
        <ValidationObserver
          ref="observer"
          v-slot="{ invalid }"
          class="tsny_form"
        >
          <logo-full />
          <b-row>
            <b-col>
              <BTextInputValidated
                rules="required|email"
                type="email"
                label="Email"
                name="Email"
                v-model="email"
                @keyup.enter.native="logIn"
              />
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <BTextInputValidated
                rules="required"
                name="Password"
                type="password"
                label="Password"
                v-model="password"
                @keyup.enter.native="logIn"
              />
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-link id="forgotPassword" @click="forgotPassword"
                >I forgot my password
              </b-link>
            </b-col>
          </b-row>
          <b-row align-h="center" class="mt-5">
            <b-button class="w-50" :disabled="invalid" @click="logIn"
              >SIGN IN</b-button
            >
            <p v-if="loginError" class="tsny_status-text">
              Your credentials were not recognized. Please check your email and
              password combination and try again
            </p>
          </b-row>
        </ValidationObserver>
      </b-col>
      <b-col />
    </b-row>
  </b-container>
</template>

<script>
import { mapActions } from "vuex";
import { ValidationObserver } from "vee-validate";
import BTextInputValidated from "../../components/FormInputs/BTextInputValidated";

export default {
  name: "Login",
  components: { ValidationObserver, BTextInputValidated },
  data: () => ({
    email: null,
    password: null,
    loginError: null
  }),
  methods: {
    ...mapActions({ vuexLogIn: "logIn" }),
    forgotPassword: function() {
      this.$router.push("/requestPasswordReset");
    },
    logIn: async function() {
      let $comp = this,
        isValid = await this.$refs.observer.validate();

      if (!isValid) return;

      $comp.loginError = false;

      return $comp
        .vuexLogIn({
          email: $comp.email,
          password: $comp.password
        })
        .then(loginError => {
          if (loginError) {
            $comp.loginError = loginError;
          } else {
            this.$router.push("/");
          }
        });
    }
  }
};
</script>

<style scoped>
#forgotPassword {
  font-family: expo-sans-pro, sans-serif;
  float: left;
  color: #9f9f9f;
}
</style>
